import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";
import { useState } from "react";

export default function Dashboard() {
  const [open, setOpen] = useState(true);

  return (
    <>
      <Sidebar open={open} />

      <div
        style={{
          marginLeft: open ? 220 : 0,
          transition: "margin-left 0.3s ease",
        }}
      >
        <Navbar toggle={() => setOpen(!open)} />

        <div className="p-4">
          <Outlet />
        </div>
      </div>
    </>
  );
}
